import type { ComponentProps } from "react"
import { TRAVELTIME_CAR_ICON_PATH } from "@/v2-ui/icon/custom/traveltimeCar/traveltimeCar.constants"

export default function TraveltimeCar(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d={TRAVELTIME_CAR_ICON_PATH}
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
      />
    </svg>
  )
}
